import Model, { attr } from '@ember-data/model';

export interface PledgeItemToKeep {
  id: string;
}

export default class MergeContactModel extends Model {
  @attr('string')
  declare keepContactId: string;

  @attr('string')
  declare mergeContactId: string;

  // keepPledgeId is old way of keeping pledges
  @attr('string')
  declare keepPledgeId?: string;

  // pledgesToKeep is new way of keeping pledges
  @attr()
  declare pledgeItemsToKeep?: Array<PledgeItemToKeep>;

  @attr('string')
  declare name: string;

  @attr('string')
  declare mailingName?: string;

  @attr('string')
  declare firstName?: string;

  @attr('string')
  declare lastName?: string;

  @attr('string')
  declare spouseFirstName?: string;

  @attr('string')
  declare spouseLastName?: string;

  @attr('string')
  declare address1?: string;

  @attr('string')
  declare address2?: string;

  @attr('string')
  declare city?: string;

  @attr('string')
  declare state?: string;

  @attr('string')
  declare zip?: string;

  @attr('string')
  declare country?: string;

  @attr('boolean')
  declare deceased: boolean;

  @attr('boolean')
  declare spouseDeceased: boolean;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'merge-contact': MergeContactModel;
  }
}
